module.exports = __webpack_public_path__ + "static/yago-60cec92e363e2a29aa143bd697ff288f.png";